import classnames from 'classnames'
import { useCallback, useMemo } from 'react'

import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import { useShowNewPdpUI } from '@src/quince-site-pdp/src/templates/productPage/hooks/useShowNewPdpUI'

import styles from './productOfferMessage.module.scss'
import { getTrackerAddedComboMessageOffer } from './utils'

export interface ProductOfferMessageProps {
  hideOfferMessage?: boolean
  offerMessageFromPC?: string
  productId?: number
  showFinalSaleMessage?: boolean
}

const ProductOfferMessage = (props: ProductOfferMessageProps) => {
  const { productId, offerMessageFromPC } = props
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_offer_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const offerMessageWithTracker = useMemo(
    () => (offerMessageFromPC ? getTrackerAddedComboMessageOffer(offerMessageFromPC, productId) : offerMessageFromPC),
    [offerMessageFromPC, productId],
  )
  const showNewPdpUI = useShowNewPdpUI()
  return (
    <>
      {!props.hideOfferMessage && offerMessageWithTracker && (
        <div
          className={classnames(
            styles.offermessage,
            showNewPdpUI && styles.offermessage_adjustedPadding,
            styles.offermessage__offerMessageWithMto,
            showNewPdpUI && styles.offermessage__offerMessageWithMto_adjustedPadding,
          )}
          ref={trackIsVisibleRef}
        >
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(offerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}

export default ProductOfferMessage
